import feedbackRoutes from "./feedbackRoutes";
import feedbackStore from "./feedbackStore";

export default {
  install(Vue, options) {
    /* register store and routes */
    if (options.router) options.router.addRoute(...feedbackRoutes);
    if (options.store) options.store.registerModule("Feedback", feedbackStore);
  },
};
